<template>
  <main>
    <div class="left-panel">
      <Sidebar />
    </div>
    <div class="right-panel">
      <Header/>
      <Breadcrumb :list="list"/>
      <div class="right-panel-view">
        <router-view />
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
import Header from "@/components/Partials/header";
import Sidebar from "@/components/Containers/sidebar";
import Breadcrumb from "@/components/Containers/breadcrumb";
import store from "@/store";

export default {
  name: "App",
  data(){
    return{
      isMobile: false
    }
  },
  components: {
    Header,
    Sidebar,
    Breadcrumb
  },
  computed: {
    list: function() {
      console.log("this.$route", this.$route);
      return this.$route.matched.filter(route => route.name);
      // return [];
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Containers/Landing.vue